import * as React from 'react'
import { FieldModel } from 'typings/api-models/creditCheck'
import Label from './label'

export default class CheckBox extends React.Component<CheckBoxProps> {
  public render(): JSX.Element {
    const { field, handleChange } = this.props

    return (
      <div>
        <input
          type="checkbox"
          id={field.name}
          onChange={(e: React.ChangeEvent<HTMLInputElement>): void => handleChange(field, e, true)}
          checked={field.value}
        />
        <Label htmlFor={field.name} id={field.name + '-label'}>
          {field.label}
        </Label>
      </div>
    )
  }
}

/* tslint:disable no-any */
interface CheckBoxProps extends React.AllHTMLAttributes<HTMLInputElement> {
  field: FieldModel<boolean>
  handleChange: any
}
/* tslint:enable no-any */



// WEBPACK FOOTER //
// ./src/components/_atoms/checkbox.tsx